// Pure data — no JSX, no dependencies — so both webpack (for the app) and
// Node (for scripts/prerender.mjs) can import it.
//
// To register a NEW public page, add a route entry here and it will be
// picked up by SEO + prerender + sitemap automatically.

export const STATIC_PUBLIC_ROUTES = [
  {
    path: "/",
    changefreq: "weekly",
    priority: 1.0,
    seo: {
      title: "Karen Boley Counselling | Registered Therapist in Delta & Tsawwassen, BC",
      description:
        "Warm, patient-centred counselling in Delta and Tsawwassen, BC with Karen Boley, MACP, MSEd, CCC. Support for anxiety, depression, burnout, OCD, perinatal issues, neurodivergence and couples. Book a free 20-minute consultation.",
      waitFor: "[data-testid='hero-section']",
    },
  },
  {
    path: "/blog",
    changefreq: "weekly",
    priority: 0.7,
    seo: {
      title: "Journal | Karen Boley Counselling — Delta, BC",
      description:
        "Reflections on therapy, growth and everyday life from Karen Boley Counselling in Delta & Tsawwassen, BC.",
      waitFor: "[data-testid='blog-grid'], [data-testid='blog-empty']",
    },
  },
];
